// assets
import { IconBrandChrome, IconHelp } from '@tabler/icons';
import { UseLang } from '../../../context';

// constant
const icons = { IconBrandChrome, IconHelp };

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const bets = {
    id: 'bets',
    type: 'group',
    children: [
        {
            id: 'bets',
            title: 'Bets',
            type: 'collapse',
            url: '/sample-page',
            icon: icons.IconBrandChrome,
            children: [
                {
                    id: 'slips',
                    title: 'Slips',
                    type: 'item',
                    url: '/bets/slips',
                    breadcrumbs: true
                },
                // {
                //     id: 'acceptedBets(hdp/ou)',
                //     title: 'Body Slips',
                //     type: 'item',
                //     url: '/bets/acceptedBetsHdp',
                //     breadcrumbs: true
                // },
                // {
                //     id: 'acceptedBets(mixParlay)',
                //     title: 'Mix Parlay Slips',
                //     type: 'item',
                //     url: '/bets/acceptedBetsParlay',
                //     breadcrumbs: true
                // },
                // {
                //     id: 'rejectedBetList',
                //     title: 'Rejected Slips',
                //     type: 'item',
                //     url: '/bets/rejectedBets',
                //     breadcrumbs: true
                // },

          ]
        }
    ]
};

export default bets;
